module.exports = __webpack_public_path__ + "img/header-weddingRingsSlim@2x.d44f7c7.jpg";